import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M0 3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v4h3a1 1 0 0 1 .707.293l4 4A1 1 0 0 1 24 12v4a1 1 0 0 1-1 1h-2.337a3.5 3.5 0 1 1-6.326 0H8.663a3.5 3.5 0 1 1-6.326 0H1a1 1 0 0 1-1-1V3Zm14 12V4H2v11h12Zm2 0V9h2.586L22 12.414V15h-6ZM5.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm12 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
